<script setup>
import {onMounted, reactive, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {Permissions} from "@/Utils/Permissions";

const data = reactive({
  loading: true,
  editing: false,
  editingItem: null,
  presignedUrl: null,
  items: [],
  rejectedItems: [],
  headers: [
    {
      title: 'File Name',
      align: 'start',
      key: 'original_filename'
    },
    {
      title: 'Sent By',
      align: 'start',
      key: 'sent_by'
    },
    {
      title: 'Client',
      align: 'start',
      key: 'client'
    },
    {
      title: 'Received On',
      align: 'start',
      key: 'received_on'
    },
    {
      title: 'Claim Data',
      align: 'start',
      key: 'actions'
    }
  ],
  rejectedHeaders: [
    {
      title: 'File Name',
      align: 'start',
      key: 'original_filename'
    },
    {
      title: 'Sent By',
      align: 'start',
      key: 'sent_by'
    },
    {
      title: 'Rejected Reason',
      align: 'start',
      key: 'rejected_reason'
    },
    {
      title: 'Rejected On',
      align: 'start',
      key: 'rejected_on'
    }
  ],
  search: '',
  rejectedSearch: ''
});

const getPendingClaims = async() => {
    await ApiWrapper.get('pending-claims', 'list')
      .then((response) => {
        if(response.pendingClaims){
          data.items = response.pendingClaims;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(() => {
        data.loading = false;
      })
}

const getRejectedClaims = async() => {
  await ApiWrapper.get('pending-claims', 'list-rejected')
      .then((response) => {
        if(response.rejectedClaims){
          data.rejectedItems = response.rejectedClaims;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(() => {
        data.loading = false;
      })
}

const getData = async() => {
  await getPendingClaims();
  await getRejectedClaims();
}

const formatTimestampToDate = (date) => {
  let d = new Date(date).toISOString().split('T');
  return d[0].toString();
}

onMounted(()=>{
  getData();
});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Pending Claim Data</v-toolbar-title>
        <v-progress-linear :active="data.loading" :indeterminate="data.loading" absolute bottom color="primary">
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table density="compact" :items="data.items" :headers="data.headers" :search="data.search" :loading="data.loading"
                    loading-text="Loading... Please wait">
        <template v-slot:[`item.received_on`]="{ item }" >
          {{ formatTimestampToDate(item.received_on) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }" >
          <RouterLink :to="`/emailimport/${item.id}`" v-if="Permissions.checkPermissions(['claims.create'])">
            <v-btn color="primary" variant="elevated" size="small" class="m-3">
              Review
            </v-btn>
          </RouterLink>
        </template>

      </v-data-table>
    </v-card>
    <v-spacer/>
    <v-card class="elevation-2 mt-5" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Rejected Claims</v-toolbar-title>
        <v-progress-linear :active="data.loading" :indeterminate="data.loading" absolute bottom color="primary">
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-data-table density="compact" :items="data.rejectedItems" :headers="data.rejectedHeaders" :search="data.rejectedSearch" :loading="data.loading"
                    loading-text="Loading... Please wait">
        <template v-slot:[`item.rejected_on`]="{ item }" >
          {{ formatTimestampToDate(item.rejected_on) }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
v-container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>